import * as React from 'react';

import type { OpenDialogFn } from './DialogProvider';
import useDialog from './useDialog';

export type WithDialogProps = {
  openDialog: OpenDialogFn;
  closeDialog?: () => void;
};

const withDialog = <T extends WithDialogProps>(Component: React.ComponentType<T>) => {
  return (props: T) => {
    const useDialogProps = useDialog();

    return <Component {...props} {...useDialogProps} />;
  };
};

export default withDialog;
